export default {
    errorsRootKey: 'callStatusMappings',
    resource: 'CallStatusMappings',
    actions: ['index','show','create','update', 'destroy'],

    uploadFile(file) {
        let formData = new FormData()
        formData.append('file', file)

        return Vue.http.post('CallStatusMappings/upload-file',formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => response.data)
    }
}